export const emailRegex: RegExp = /^[a-zA-Z\d+_.-]+@[a-zA-Z\d.-]+$/;
